var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _path7, _path8, _ellipse, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotarticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "url(#paint0_linear_3926_13644)",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0662 26.2223C36.0662 24.5654 37.4093 23.2223 39.0662 23.2223H55.7949V65.0257H23.9744V37.4531C23.9744 35.7962 25.3175 34.4531 26.9744 34.4531H33.0662C34.723 34.4531 36.0662 33.1099 36.0662 31.4531V26.2223Z",
    fill: "#167092",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9528 68.7865V27.1165C60.9528 26.3774 60.3369 25.7768 59.578 25.7768H57.2571V63.5262C57.2571 65.1794 55.8753 66.5252 54.1776 66.5252L26.71 66.5249V68.7867C26.71 69.5257 27.3263 70.1264 28.0848 70.1264H59.5775C60.3367 70.1264 60.9528 69.5255 60.9528 68.7865ZM21.3104 63.5256C21.3104 64.2632 21.9275 64.8638 22.6859 64.8638H54.1787C54.9371 64.8638 55.5535 64.2631 55.5535 63.5256V21.8556C55.5535 21.1169 54.9375 20.5159 54.1787 20.5159L32.9262 20.5155C32.9021 20.5155 32.8796 20.5178 32.8559 20.5189V28.9767C32.8559 30.5146 31.5724 31.7665 29.9942 31.7665H21.314C21.3125 31.7888 21.3102 31.8119 21.3102 31.8349L21.3104 63.5256ZM31.1515 21.6891V28.9761C31.1515 29.5987 30.6322 30.1052 29.9941 30.1052H22.5159L31.1515 21.6891ZM59.5779 24.1155H57.257L57.2573 21.8551C57.2573 20.2007 55.8756 18.855 54.1779 18.855L32.9254 18.8546C32.0913 18.8546 31.3383 19.1587 30.748 19.7336L20.5087 29.7127C19.9184 30.288 19.6067 31.0219 19.6067 31.8339V63.5247C19.6067 65.178 20.9884 66.5238 22.6861 66.5238H25.0071V68.7856C25.0071 70.44 26.3888 71.7865 28.0857 71.7865H59.5785C61.2762 71.7865 62.658 70.44 62.658 68.7856L62.6576 27.1166C62.6572 25.4622 61.2764 24.1155 59.5779 24.1155Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0561 44.7166C31.1768 44.8372 31.3724 44.8372 31.493 44.7166L32.9174 43.2922C33.1127 43.0969 33.4293 43.0969 33.6245 43.2922L35.0489 44.7166C35.1696 44.8372 35.3652 44.8372 35.4858 44.7166V44.7166C35.6065 44.5959 35.6065 44.4003 35.4858 44.2796L34.0615 42.8552C33.8662 42.66 33.8662 42.3434 34.0615 42.1481L35.4858 40.7238C35.6065 40.6031 35.6065 40.4075 35.4858 40.2868V40.2868C35.3652 40.1662 35.1696 40.1662 35.0489 40.2868L33.6245 41.7112C33.4293 41.9065 33.1127 41.9065 32.9174 41.7112L31.493 40.2868C31.3724 40.1662 31.1768 40.1662 31.0561 40.2868V40.2868C30.9355 40.4075 30.9355 40.6031 31.0561 40.7238L32.4805 42.1481C32.6758 42.3434 32.6758 42.66 32.4805 42.8552L31.0561 44.2796C30.9355 44.4003 30.9355 44.5959 31.0561 44.7166V44.7166Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4116 44.7166C42.5322 44.8372 42.7279 44.8372 42.8485 44.7166L44.2729 43.2922C44.4682 43.0969 44.7847 43.0969 44.98 43.2922L46.4044 44.7166C46.525 44.8372 46.7207 44.8372 46.8413 44.7166V44.7166C46.962 44.5959 46.962 44.4003 46.8413 44.2796L45.4169 42.8552C45.2217 42.66 45.2217 42.3434 45.4169 42.1481L46.8413 40.7238C46.962 40.6031 46.962 40.4075 46.8413 40.2868V40.2868C46.7207 40.1662 46.525 40.1662 46.4044 40.2868L44.98 41.7112C44.7847 41.9065 44.4682 41.9065 44.2729 41.7112L42.8485 40.2868C42.7279 40.1662 42.5322 40.1662 42.4116 40.2868V40.2868C42.2909 40.4075 42.2909 40.6031 42.4116 40.7238L43.836 42.1481C44.0312 42.3434 44.0312 42.66 43.836 42.8552L42.4116 44.2796C42.2909 44.4003 42.2909 44.5959 42.4116 44.7166V44.7166Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4602 54.4187L32.6128 54.2695C36.1953 50.7685 41.9379 50.8353 45.438 54.4187V54.4187",
    stroke: "#167092",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0513 23.2223H55.7949V63.0257C55.7949 64.1303 54.8994 65.0257 53.7949 65.0257H52.0513V23.2223Z",
    fill: "#167092",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7306,
    cy: 66.5855,
    r: 9.04701,
    fill: "#A9C7D2",
    stroke: "#167092",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6072 69.709C53.7773 69.8791 54.0532 69.8791 54.2233 69.709L56.3771 67.5552C56.5724 67.3599 56.889 67.3599 57.0842 67.5552L59.238 69.709C59.4082 69.8791 59.6841 69.8791 59.8542 69.709V69.709C60.0244 69.5388 60.0244 69.2629 59.8542 69.0928L57.7004 66.939C57.5052 66.7437 57.5052 66.4271 57.7004 66.2319L59.8542 64.0781C60.0244 63.9079 60.0244 63.6321 59.8542 63.4619V63.4619C59.6841 63.2917 59.4082 63.2917 59.238 63.4619L57.0842 65.6157C56.889 65.811 56.5724 65.811 56.3771 65.6157L54.2233 63.4619C54.0532 63.2917 53.7773 63.2917 53.6072 63.4619V63.4619C53.437 63.6321 53.437 63.9079 53.6072 64.0781L55.761 66.2319C55.9562 66.4271 55.9562 66.7437 55.761 66.939L53.6072 69.0928C53.437 69.2629 53.437 69.5388 53.6072 69.709V69.709Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7535 42.8209L68.3441 32.3687C70.5078 29.169 71.3641 25.2612 70.737 21.4488C70.11 17.6364 68.0472 14.2091 64.9728 11.8717C61.8983 9.53425 58.046 8.46437 54.208 8.88202C50.3699 9.29967 46.8377 11.1731 44.3378 14.1171C41.8379 17.0611 40.5602 20.8519 40.7675 24.71C40.9748 28.5681 42.6513 32.2003 45.4522 34.8597C48.2532 37.5191 51.9658 39.0036 55.8266 39.0079C59.6873 39.0122 63.4028 37.536 66.2091 34.8829L77.5684 45.3392C77.7365 45.4834 77.9315 45.5929 78.1422 45.6613C78.3528 45.7297 78.5749 45.7556 78.7956 45.7377C79.0162 45.7198 79.2312 45.6583 79.428 45.5569C79.6249 45.4554 79.7997 45.3159 79.9424 45.1465C80.2184 44.81 80.3529 44.3794 80.3177 43.9455C80.2825 43.5116 80.0802 43.1084 79.7535 42.8209ZM56.8302 35.6444C54.5157 35.8323 52.1973 35.3291 50.1683 34.1985C48.1393 33.0679 46.4909 31.3606 45.4314 29.2925C44.3719 27.2244 43.949 24.8884 44.2161 22.5799C44.4832 20.2714 45.4283 18.0941 46.932 16.3233C48.4356 14.5526 50.4303 13.2679 52.6637 12.6317C54.8971 11.9955 57.269 12.0363 59.4793 12.7491C61.6897 13.462 63.6393 14.8147 65.0815 16.6362C66.5238 18.4578 67.394 20.6664 67.5821 22.9827C67.8342 26.0888 66.8431 29.1678 64.8268 31.5423C62.8104 33.9168 59.934 35.3924 56.8302 35.6444Z",
    fill: "#FF8300",
    stroke: "#EBF4F4",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.8797,
    cy: 23.9223,
    rx: 11.8307,
    ry: 11.8307,
    transform: "rotate(-4.64166 55.8797 23.9223)",
    fill: "white",
    fillOpacity: 0.61
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.265,
    cy: 48.8034,
    r: 1.24786,
    fill: "#167092"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.0001,
    cy: 31.3333,
    r: 1.24786,
    fill: "#167092"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.265,
    cy: 19.4786,
    r: 1.24786,
    fill: "#167092"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9915,
    cy: 46.9317,
    r: 1.24786,
    fill: "#167092"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9571,
    cy: 14.4871,
    r: 1.24786,
    fill: "#167092"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2562,
    cy: 67.5214,
    r: 2.49573,
    stroke: "#167092"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1112,
    cy: 20.7264,
    r: 2.49573,
    stroke: "#167092"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 79,
    x2: 89.4872,
    y2: 79,
    stroke: "#167092",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3075 51.2991V53.8543H80.7522",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4369 51.2992V53.8545H87.9922",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3075 58.5391V55.9838H80.7522",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4369 58.5391V55.9838H87.9922",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3926_13644",
    x1: 49,
    y1: 0,
    x2: 49.5632,
    y2: 117.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009B94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B94",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarticle);
export default __webpack_public_path__ + "static/media/notarticle.eda83ac8ad9d0ae2f819c27b04649f59.svg";
export { ForwardRef as ReactComponent };